import { render, staticRenderFns } from "./ExpenseInvestigationOnboarding.vue?vue&type=template&id=588fba6a&scoped=true&"
import script from "./ExpenseInvestigationOnboarding.vue?vue&type=script&lang=js&"
export * from "./ExpenseInvestigationOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseInvestigationOnboarding.vue?vue&type=style&index=0&id=588fba6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588fba6a",
  null
  
)

export default component.exports